import { render } from "./VUEPopupSelezionaModuli.vue?vue&type=template&id=0def2542"
import script from "./VUEPopupSelezionaModuli.vue?vue&type=script&lang=js"
export * from "./VUEPopupSelezionaModuli.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__